const STORAGE_KEY = "dp_product_guide";
const INVITE_DISMISS_KEY = "dp_guide_invite_dismissed";
/** User finished or exited the first-run guide — don't auto-restart until map wipe. */
const GUIDE_OPTED_OUT_KEY = "dp_guide_opted_out";

function readRawGuideState() {
  try {
    // localStorage survives refresh and new tabs; session was losing mid-wizard.
    const fromLocal = localStorage.getItem(STORAGE_KEY);
    if (fromLocal) return fromLocal;
    return sessionStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function readGuideState() {
  try {
    const raw = readRawGuideState();
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.scriptId) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function writeGuideState(state) {
  try {
    if (!state?.scriptId) {
      localStorage.removeItem(STORAGE_KEY);
      sessionStorage.removeItem(STORAGE_KEY);
      return;
    }
    const raw = JSON.stringify(state);
    localStorage.setItem(STORAGE_KEY, raw);
    sessionStorage.setItem(STORAGE_KEY, raw);
  } catch {
    /* ignore */
  }
}

export function clearGuideState() {
  try {
    localStorage.removeItem(STORAGE_KEY);
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function readGuideInviteDismissed() {
  try {
    return localStorage.getItem(INVITE_DISMISS_KEY) === "1";
  } catch {
    return false;
  }
}

export function writeGuideInviteDismissed(dismissed) {
  try {
    if (dismissed) localStorage.setItem(INVITE_DISMISS_KEY, "1");
    else localStorage.removeItem(INVITE_DISMISS_KEY);
  } catch {
    /* ignore */
  }
}

export function readGuideOptedOut() {
  try {
    return localStorage.getItem(GUIDE_OPTED_OUT_KEY) === "1";
  } catch {
    return false;
  }
}

export function writeGuideOptedOut(optedOut) {
  try {
    if (optedOut) localStorage.setItem(GUIDE_OPTED_OUT_KEY, "1");
    else localStorage.removeItem(GUIDE_OPTED_OUT_KEY);
  } catch {
    /* ignore */
  }
}

/** Inbox: open a specific job for review when the page mounts. */
const INBOX_JOB_KEY = "dp_inbox_open_job";

export function stashInboxOpenJob(jobId) {
  const id = String(jobId || "").trim();
  if (!id) return;
  try {
    sessionStorage.setItem(INBOX_JOB_KEY, id);
  } catch {
    /* ignore */
  }
}

export function consumeInboxOpenJob() {
  try {
    const id = sessionStorage.getItem(INBOX_JOB_KEY);
    sessionStorage.removeItem(INBOX_JOB_KEY);
    return String(id || "").trim() || null;
  } catch {
    return null;
  }
}

/** Stash + notify Inbox (works even when Inbox is already mounted). */
export const INBOX_OPEN_JOB_EVENT = "dp-inbox-open-job";

export function requestInboxOpenJob(jobId) {
  const id = String(jobId || "").trim();
  if (!id) return;
  stashInboxOpenJob(id);
  try {
    window.dispatchEvent(
      new CustomEvent(INBOX_OPEN_JOB_EVENT, { detail: { jobId: id } })
    );
  } catch {
    /* ignore */
  }
}
